import type { Database } from '~/apis/generated/database'
import { useApi } from '~/composables/useApi'
import { useSupabaseClient } from '~/composables/useSupabaseClient'
import type { Organization } from '~/entities/organization'

type UpdateOrganizationParams = {
  name?: string
  displayName?: string
  mfaEnabled?: boolean
}

export const getOrganization = async (organizationId: number) => {
  const { data, error } = await useSupabaseClient<Database>()
    .from('organizations')
    .select()
    .eq('id', organizationId)
    .single()

  if (error) {
    throw error
  }

  return data
}

export const getOrganizationByAccountId = async (accountId: string) => {
  const { data, error } = await useSupabaseClient<Database>()
    .from('organizations')
    .select('*, user_accounts!inner(id)')
    .eq('user_accounts.id', accountId)
    .single()

  if (error) {
    throw error
  }

  const { user_accounts: _, ...organization } = data
  return organization as Organization
}

export const updateOrganization = async (params: UpdateOrganizationParams): Promise<void> => {
  const { client } = useApi()
  // 対象の組織はサーバ側でログイン中の管理者から解決されるため、組織 ID は送らない。
  // undefined の項目は JSON に含まれず、サーバ側では省略扱い（＝変更しない）になる
  const response = await client.organization.$patch({
    json: {
      name: params.name,
      displayName: params.displayName,
      mfaEnabled: params.mfaEnabled,
    },
  })

  if (!response.ok) {
    const body = await response.text()
    throw new Error(`Failed to update organization: ${response.status} ${response.statusText}: ${body}`)
  }
}
